import React, {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useSearchParams } from "react-router-dom";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import AddRawMaterialModal from "./AddRawMaterialModal";
import UpdateMaterialModal from "./UpdateMaterialModal";
import Pagination from "../../Common/Pagination/Pagination";
import Creatable from "react-select/creatable";
import { minDate } from "../../Constants/Constants";
import _ from "lodash";
const RawMaterialDetails = () => {
  const gridRef = useRef();
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  // console.log("rowData", rowData)
  const [rmvBtn, setRmvBtn] = useState(false);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [PartyName, setPartyName] = useState([]);
  const [selectedPartyName, setSelectedPartyName] = useState(null);
  const [partyNameOptions, setPartyNameOptions] = useState([]);
  const [location, setLocation] = useState("");
  const [company, setCompany] = useState([]);
  const [storeMaterialNames, setStoreMaterialNames] = useState([]);
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  const [companyId, setCompanyId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };
  const urlSearchString = window.location.search;
  const params = new URLSearchParams(urlSearchString);
  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId,
    material_id: selectedMaterialId,
    party_name: "",
    production_date: "",
    incoming_date: "",
  });
  const [urlCompanyId, setURLCompanyId] = useState(
    parseInt(params.get("companyId")) || 0
  );
  // const urlCompanyId = parseInt(params.get("companyId"));

  useEffect(() => {
    setCompanyId(urlCompanyId);
  }, [urlCompanyId]);

  useEffect(() => {
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: urlCompanyId ? urlCompanyId : companyId,
    }));
  }, []);

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };

  const handlePartyNameChange = (selectedOption) => {
    // console.log("selectedOption", selectedOption)
    setSelectedPartyName(selectedOption);
  };

  // const handleCreate = async (inputValue) => {
  //   // Handle the creation of a new option here
  //   // console.log("Option created:", inputValue);
  //   let BASE_URL = SERVER_URL + `/api/raw-mat/party-name/${user_id}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "POST",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       party_name: inputValue,
  //     }),
  //   });
  //   const response = await res.json();
  //   if (res.ok) {
  //     console.log(response);
  //     setTimeout(() => {
  //       toast.success(response.message);
  //       // navigate("/dashboard");
  //     }, 1000);
  //     getData();
  //   } else {
  //     toast.error(response.message);
  //     getData();
  //   }

  //   // Add the new option to the options list if needed
  //   const newOption = { label: inputValue, value: inputValue };
  //   setPartyNameOptions([...partyNameOptions, newOption]);

  //   // Set the selected party name to the newly created option
  //   setSelectedPartyName(newOption);
  // };
  // useEffect(() => {
  //   handleCreate();
  // }, []);

  // const handleMaterialChange = (e) => {
  //   const selectedMaterial = PartyName.find(
  //     (item) => item.material_name === e.target.value
  //   );
  //   // setSelectedMaterialId(selectedMaterial.id);

  //   if (selectedMaterial) {
  //     setSelectedMaterialId(selectedMaterial.id);

  //     // Update filterCriteria with the selected company's ID
  //     setfilterCriteria({
  //       ...filterCriteria,
  //       party_name_id: selectedMaterial.id,
  //     });
  //   }
  //   // setSelectedCompanyId(selectedCompany ? selectedCompany.company_id : "");
  // };

  // console.log("filterCriteria", filterCriteria);
  // console.log(selectedRowsData)
  const getData = async () => {
    // let BASE_URL =
    //   SERVER_URL +
    //   `/api/raw-mat/all-raw-material-details/${user_id}`;
    let BASE_URL =
      SERVER_URL +
      `/api/raw-mat/all-raw-material-details/${user_id}?company_id=${selectedCompanyId}&material_name_id=${selectedMaterialId}&production_date=${filterCriteria.production_date}&incoming_date=${filterCriteria.incoming_date}&skip=${currentPage}&take=${pageSize}`;

    // const nonEmptyFilterCriteria = Object.fromEntries(
    //   Object.entries(filterCriteria).filter(
    //     ([key, value]) => value !== null && value !== undefined && value !== ""
    //   )
    // );

    // // Define the options object with whereFilters, skip, and take
    // const options = {
    //   whereFilters: nonEmptyFilterCriteria,
    //   skip: currentPage,
    //   take: pageSize,
    // };

    const res = await fetch(BASE_URL, {
      // method: "POST",
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(() => {
        return result.data?.map((rowData) => {
          // const dateParts = rowData.date.split("-");
          return {
            ...rowData,
            // date: `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`,
            date: moment.utc(rowData.date).format("YYYY-MM-DD").toString(),
          };
        });
      });
      gridRef.current.api.hideOverlay();
    } else {
      setRowData([]);
      gridRef.current.api.hideOverlay();
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);

  useEffect(() => {
    if (check) {
      // Show the loading overlay here when either diamondId or supplierId changes
      if (loadingOverlayVisible) {
        gridRef.current.api.showLoadingOverlay();
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: "",
      material_name_id: "",
      production_date: "",
      incoming_date: "",
    }));
    setSelectedCompanyId({ company_id: "" });
    setSelectedMaterialId({ material_name_id: "" });
    setURLCompanyId(null);
    updateURLParams("companyId", null);
  };

  const addData = (newData) => {
    // setRowData((prevData) => [...prevData, newData]);
  };

  const updateCellData = async (updatedData) => {
    // console.log("updatedData", updatedData);
    let BASE_URL = SERVER_URL + `/api/raw-mat/raw-material-details/${user_id}`;
    const {
      id,
      over_stock,
      shortage_stock,
      damage_stock,
      date,
      company_id,
      material_name_id,
    } = updatedData;
    const formattedDate = moment.utc(date, "YYYY-MM-DD").toISOString();
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        over_stock,
        shortage_stock,
        damage_stock,
        company_id,
        material_name_id,
        date: formattedDate,
      }),
    });
    const data = await res.json();
    if (res.ok) {
      getData();
      toast.success(data.message);
      //   setTotalRecords(result?.totalCount);
      gridRef.current.api.hideOverlay();
    } else {
      getData();
      toast.error(data.message);
    }
  };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateCellData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteSelectedRows = async () => {
    // Extract IDs from selected rows
    const selectedRowIds = selectedRows.map((item) => item.id);

    // Update state to remove selected rows
    setRowData((prevData) =>
      prevData.filter((row) => !selectedRowIds.includes(row.id))
    );

    // Prepare the URL for deletion
    const BASE_URL =
      SERVER_URL + `/api/raw-mat/all-raw-material-details/${user_id}`;

    try {
      // Make a DELETE request to the server
      const res = await fetch(BASE_URL, {
        method: "DELETE",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ids: selectedRowIds,
        }),
      });

      // Parse the server response
      const response = await res.json();

      // Check if the request was successful
      if (res.ok) {
        // Display success message and reset form after a delay
        setTimeout(() => {
          toast.success(response.message);
          // formRef.current.reset();
          // navigate("/dashboard");
        }, 1000);
        // Fetch updated data
        getData();
      } else {
        // Display error message if the request was not successful
        toast.error(response.message);
        // Fetch updated data
        getData();
      }
    } catch (error) {
      // Handle any network or server errors
      console.error("Error deleting rows:", error);
      // Fetch updated data
      getData();
    } finally {
      // Clear the selected rows
      setSelectedRows([]);
    }
  };

  const deleteRow = async (id) => {
    // setRowData((prevData) => prevData.filter((row) => row !== rowData));
    let BASE_URL = SERVER_URL + `/api/raw-mat/raw-material-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No.",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 100,
      minWidth: 100,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    {
      headerName: "Production Date",
      field: "production_date",
      editable: false,
      minWidth: 160,
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        const val = params.value || "-";
        return val;
      },
      // cellEditor: "agDateStringCellEditor",
    },
    {
      headerName: "Incoming Date",
      field: "incoming_date",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        const val = params.value || "-";
        return val;
      },
      editable: false,
      minWidth: 150,
      // cellEditor: "agDateStringCellEditor",
    },
    {
      headerName: "Dispatch Date",
      field: "dispatch_date",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        const val = params.value || "-";
        return val;
      },
      editable: false,
      minWidth: 150,
      // cellEditor: "agDateStringCellEditor",
    },
    {
      headerName: "Material Name",
      field: "rawMaterialName.material_name",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Party Name",
    //   field: "partyName.party_name",
    //   editable: false,
    //   width: 220,
    //   minWidth: 220,
    // },
    // {
    //   headerName: "Company Name",
    //   field: "companyDetails.company_name",
    //   valueFormatter: (params) => {
    //     const location = params.data.companyDetails.location;
    //     return `${params.value}, ${location}`;
    //   },
    //   editable: false,
    //   minWidth: 205,
    // },
    // {
    //   headerName: "Location",
    //   field: "company.location",
    //   editable: false,
    //   minWidth: 205,
    // },
    // {
    //   headerName: "Quantity/Unit",
    //   field: "quantity",
    //   editable: true,
    //   width: 140,
    //   minWidth: 140,
    // },

    {
      headerName: "Incoming Stock",
      field: "incoming_stock",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        const unit = params?.data?.rawMaterialName?.unit;
        if (params.value === null) {
          return "0 - " + unit;
        } else {
          return `${params.value} - ${unit}`;
        }
      },
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Product Quantity",
      field: "productDetails.quantity",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        const val = params.value || "-";
        return val;
      },
      editable: false,
      width: 180,
      minWidth: 180,
    },
    {
      headerName: "Product Size",
      field: "productDetails.productName.size",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        const val = params.value || "-";
        return val;
      },
      editable: false,
      width: 150,
      minWidth: 150,
    },
    // { headerName: "Unit", field: "unit", editable: true, minWidth: 205 },
    // { headerName: "Type", field: "type", editable: true, minWidth: 205 },
    {
      headerName: "Opening Stock",
      field: "opening_stock",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Consumed",
      field: "consumed_stock",
      editable: false,
      width: 120,
      minWidth: 120,
    },
    {
      headerName: "Closing Stock",
      field: "closing_stock",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Dispatch Quantity",
      field: "dispatch_qty",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        const val = params.value || "-";
        return val;
      },
      editable: false,
      width: 180,
      minWidth: 180,
    },
    // { headerName: "Status", field: "status", editable: false, minWidth: 150 },
    {
      headerName: "Over Stock",
      field: "over_stock",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        if (params.value === null) {
          return "0";
        } else {
          return params.value;
        }
      },
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Shortage Stock",
      field: "shortage_stock",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        if (params.value === null) {
          return "0";
        } else {
          return params.value;
        }
      },
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Damage Stock",
      field: "damage_stock",
      valueFormatter: (params) => {
        // Assuming 'size' is another property in your data
        if (params.value === null) {
          return "0";
        } else {
          return params.value;
        }
      },
      editable: true,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Actions",
    //   cellRenderer: (params) => (
    //     <>
    //       <button
    //         className="btn btn-outline-danger btn-sm"
    //         onClick={() => deleteRow(params.data.id)}
    //       >
    //         <i className="mdi mdi-delete" />
    //       </button>{" "}
    //       {/* <button
    //         className="btn btn-outline-secondary btn-sm"
    //         data-toggle="modal"
    //         data-target="#updateModal"
    //         onClick={() => addDataToModal(params.data)}
    //       >
    //         <i className="mdi mdi-note-edit-outline" />
    //       </button> */}
    //     </>
    //   ),
    //   minWidth: 205,
    // },
  ]);

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);

  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));

  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);
  const dataTypeDefinitions = useMemo(() => {
    return {
      object: {
        baseDataType: "object",
        extendsDataType: "object",
        valueParser: (params) => ({ name: params.newValue }),
        valueFormatter: (params) =>
          params.value == null ? "" : params.value.name,
      },
    };
  }, []);
  const getMaterialData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/raw-mat-name/all-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setMaterialData(result.data);
    } else {
      setMaterialData([]);
    }
  };
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
    getMaterialData();
    // getMaterial();
  }, []);
  const updateURLParams = (key, value) => {
    const params = new URLSearchParams(window.location.search);
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);
  };
  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);
    if (companyId) {
      setURLCompanyId(companyId);
      updateURLParams("companyId", companyId);
    } else {
      setURLCompanyId(null);
      updateURLParams("companyId", null);
    }
    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };
  const handleMaterialChange = (e) => {
    const materialId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedMaterialId(materialId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      material_name_id: materialId,
    }));
  };
  // const handleMateriaNameChange = (e) => {
  //   const selectedMaterialName = e.target.value;

  //   if (selectedMaterialName === "All Select") {
  //     // If "All Select" is chosen, reset the filterCriteria
  //     setfilterCriteria({});
  //   } else {
  //     // Find the selected company and update filterCriteria
  //     const selectedMaterial = storeMaterialNames.find(
  //       (item) => item.material_name === e.target.value
  //     );

  //     if (selectedMaterial) {
  //       setSelectedCompanyId(selectedMaterial.id);

  //       // Update filterCriteria with the selected company's ID
  //       setfilterCriteria({
  //         ...filterCriteria,
  //         material_id: selectedMaterial.id,
  //       });
  //     }
  //   }
  // };

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div
            className="card-title"
            style={{ justifyContent: "space-between" }}
          >
            Raw Material Details Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              {/* <button
                  style={{ display: handle.active ? "none" : "" }}
                  data-toggle="modal"
                  data-target="#exampleModal"
                  className="btn btn-outline-primary"
                >
                  <span className="mr-1">
                    <i className="mdi mdi-briefcase-upload" />
                  </span>
                  Add Data
                </button> */}
            </div>

            <div>
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>

          <div className="search mb-3">
            <div className="row">
              {/* <div class="col-md-3">
                  <div class="form-group">
                  <Creatable
                              isClearable
                              onChange={handlePartyNameChange}
                              onCreateOption={handleCreate}
                              options={partyNameOptions}
                              value={selectedPartyName}
                              // menuIsOpen={true}
                              menuPosition="fixed"
                            />
                  </div>
                </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="company_id">Company</label>
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyChange}
                    value={selectedCompanyId ? selectedCompanyId : companyId}
                    id="company_id"
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.company_name}, ${item.location}`}</option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="material_id">Material</label>
                  <select
                    className="form-control form-control-lg"
                    onChange={handleMaterialChange}
                    value={selectedMaterialId}
                    id="material_id"
                  >
                    <option value="">Select Material (All)</option>
                    {materialData &&
                      materialData?.length > 0 &&
                      materialData?.map((item, id) => {
                        return (
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.material_name}`}</option>
                        );
                      })}
                  </select>
                </div>
              </div>
              {/* <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control form-control-lg"
                      onChange={handleMateriaNameChange}
                    >
                      <option>All Select</option>
                      {storeMaterialNames.map((item, id) => {
                        return (
                          <>
                            <option key={id}>{`${item.material_name}`}</option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div> */}
              {/* <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Search by party name"
                    onChange={(e) =>
                      handleFilterChange("party_name", e.target.value)
                    }
                  />
                </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="production_date">Production Date</label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Search by Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("production_date", e.target.value)
                    }
                    id="production_date"
                    value={filterCriteria.production_date}
                    min={minDate}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="incoming_date">Incoming Date</label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Select Incoming Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("incoming_date", e.target.value)
                    }
                    id="incoming_date"
                    value={filterCriteria.incoming_date}
                    min={minDate}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 555 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                dataTypeDefinitions={dataTypeDefinitions}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          {/* <AddRawMaterialModal getData={getData} /> */}
          <UpdateMaterialModal
            getData={getData}
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default RawMaterialDetails;
